import moment from "moment/moment";
import React from "react";

import { CharacterCounter } from "../../../../../../../component-library/CharacterCounter/CharacterCounter";
import { FormTextArea } from "../../../../../../../component-library/FormFields/FormTextArea/FormTextArea";

import { INTERVENTION_AND_PLAN_CHARACTER_LIMIT_ERROR } from "./InterventionAndPlanV2FormSchema";

import "./styles.scss";

export const InterventionAndPlanV2GoalField = ({
  formikProps,
  goalAndObjectiveProgress,
  goalNumber,
  saveNoteContentOnChange,
}) => {
  const goalNumberValue = Number(goalNumber.split("_")[1]);
  const goalText = goalAndObjectiveProgress.goal_other_text ?? goalAndObjectiveProgress.goal_text;

  return (
    <div
      className="InterventionAndPlanV2GoalField--container"
      key={goalAndObjectiveProgress.goal_text_id}
    >
      <p className="InterventionAndPlanV2GoalField--title">
        {goalNumberValue}. {goalText}
      </p>
      <div className="InterventionAndPlanV2GoalField--objective_container">
        {goalAndObjectiveProgress.objectives.map((objective) => {
          const objectiveText = objective.objective_other_text ?? objective.objective_text;

          return (
            <p
              className="InterventionAndPlanV2GoalField--objective_text"
              key={objective.objective_text_id}
            >
              {objectiveText} • Target:{" "}
              {moment(objective.objective_target_timestamp).format("MM/DD/YY")}
            </p>
          );
        })}
      </div>
      <FormTextArea
        formikProps={formikProps}
        inputClassName="InterventionAndPlanV2GoalField--intervention_and_plan_input"
        name={`${goalNumber}.interventions_and_plans`}
        onChangeCallBack={(name, value) => {
          saveNoteContentOnChange(name, value);
        }}
        placeholder="Describe intervention and plans..."
        testId={`InterventionAndPlanV2GoalField_field_${goalNumber}`}
        triggerErrorOnChange
      />
      {formikProps.errors?.[goalNumber]?.interventions_and_plans ===
        INTERVENTION_AND_PLAN_CHARACTER_LIMIT_ERROR && (
        <CharacterCounter
          characterLimit={4000}
          length={formikProps.values[goalNumber].interventions_and_plans.length}
        />
      )}
    </div>
  );
};
